import { ExternalLink, PartyPopper } from "lucide-react";
import { Link } from "react-router-dom";
import SiteLayout from "../../components/layout/SiteLayout";
import { focusRing } from "../../components/ui/focusRing";

function UpgradeSuccess() {
  return (
    <SiteLayout navVariant="inner" footerVariant="home">
      <main className="flex-1 flex items-center justify-center px-6 pt-24 pb-12">
        <div className="max-w-md w-full bg-white rounded-3xl border border-orange-200 shadow-sm p-8 text-center">
          <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <PartyPopper className="w-8 h-8 text-emerald-700" />
          </div>
          <h1 className="text-3xl font-bold text-stone-800 mb-4">🎉 Thank you!</h1>
          <p className="text-stone-600 mb-2">Your Kyubot Pro subscription is now active.</p>
          <p className="text-stone-500 text-sm mb-8">
            <em>It may take a few seconds to reflect in Slack.</em>
          </p>
          <div className="flex flex-col gap-4 items-center">
            <a
              href="slack://open"
              className={`inline-flex items-center gap-2 bg-brand-orange text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-brand-orange-hover transition-all shadow-lg shadow-brand-orange/20 ${focusRing}`}
            >
              <ExternalLink className="w-5 h-5" />
              Open Slack
            </a>
            <Link
              to="/"
              className={`text-stone-600 hover:text-brand-orange text-sm transition-colors ${focusRing}`}
            >
              Return to homepage
            </Link>
          </div>
        </div>
      </main>
    </SiteLayout>
  );
}

export default UpgradeSuccess;
